import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { getLicenseStatus, getPaymentMe, isPayAdmin, formatYmd } from '../utils/paymentInfo';

// Lisenziya bitməyə az qalanda (yalnız tenant admini):
//   1–2 gün → sağ aşağı küncdə kiçik ağ nişan (sakit)
//   0 gün   → yuxarıda narıncı zolaq
// ✕ ilə bağlanır (bu sessiya üçün), növbəti girişdə yenə çıxır.
export default function LicenseNotice() {
    const { user } = useAuthStore();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [license, setLicense] = useState(null);
    const [hidden, setHidden] = useState(() => {
        try { return sessionStorage.getItem('pos_license_notice_hidden') === '1'; } catch { return false; }
    });
    const admin = isPayAdmin(user);

    useEffect(() => {
        if (!admin) return undefined;
        let alive = true;
        getLicenseStatus().then((l) => { if (alive) setLicense(l); }).catch(() => {});
        // Bölmə açılanda gözləməsin deyə ödəniş məlumatını arxa fonda əvvəlcədən al (5 dəq. keş)
        const t = setTimeout(() => { getPaymentMe().catch(() => {}); }, 4000);
        return () => { alive = false; clearTimeout(t); };
    }, [admin]);

    if (!admin || hidden || !license || license.state !== 'active' || pathname === '/admin/odenis') return null;
    const days = Number(license.daysLeft);
    if (!Number.isFinite(days) || days > 2 || days < 0) return null;

    const close = () => {
        setHidden(true);
        try { sessionStorage.setItem('pos_license_notice_hidden', '1'); } catch { /* ignore */ }
    };
    const pay = () => navigate('/admin/odenis');

    if (days === 0) {
        return (
            <div className="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-3 bg-orange-500 px-4 py-2 text-sm text-white shadow md:pl-64">
                <span className="font-semibold">
                    Lisenziya bu gün bitir{license.expiry ? ` (${formatYmd(license.expiry)})` : ''}
                </span>
                <button type="button" onClick={pay} className="rounded-lg bg-white px-3 py-1 text-xs font-bold text-orange-600 hover:bg-orange-50">İndi ödə</button>
                <button type="button" onClick={close} aria-label="Bağla" className="ml-1 px-1 text-white/80 hover:text-white">✕</button>
            </div>
        );
    }

    return (
        <div className="fixed bottom-4 right-4 z-[60] flex items-center gap-2 rounded-full bg-white py-1.5 pl-3 pr-1.5 text-xs text-gray-700 shadow-lg ring-1 ring-gray-200">
            <span className="h-2 w-2 rounded-full bg-amber-500" />
            <span className="font-semibold">Lisenziya: {days} gün qalıb</span>
            <button type="button" onClick={pay} className="rounded-full bg-[#0090bb] px-2.5 py-1 font-bold text-white hover:bg-[#007ea4]">Ödə</button>
            <button type="button" onClick={close} aria-label="Bağla" className="px-1 text-gray-400 hover:text-gray-600">✕</button>
        </div>
    );
}
